import { createApiSlice } from "@common";
import { CRUD_EMPLOYEE_STATUS_REASON } from "@routes";

const apiConfig = [
  { name: "addEmployeeStatusReason",    method: "post",   url: CRUD_EMPLOYEE_STATUS_REASON, stateKey: "message" },
  { name: "getEmployeeStatusReason",    method: "get",    url: CRUD_EMPLOYEE_STATUS_REASON, stateKey: "data"    },
  { name: "getEmployeeStatusReasonById",method: "get",    url: CRUD_EMPLOYEE_STATUS_REASON, stateKey: "data"    },
  { name: "updateEmployeeStatusReason", method: "put",    url: CRUD_EMPLOYEE_STATUS_REASON, stateKey: "message" },
  { name: "deleteEmployeeStatusReason", method: "delete", url: CRUD_EMPLOYEE_STATUS_REASON, stateKey: "message" },
];

const customReducers = {
  initialState: { data: [], additionalData: [] },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("productType", apiConfig, customReducers);
const employeeTypeSlice = slice;

export default employeeTypeSlice.reducer;

export const { addEmployeeStatusReason,getEmployeeStatusReasonById, getEmployeeStatusReason, updateEmployeeStatusReason, deleteEmployeeStatusReason } = thunks;
export const { rowSelect } = actions;
